import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d6373e00&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d6373e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6373e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6373e00')) {
      api.createRecord('d6373e00', component.options)
    } else {
      api.reload('d6373e00', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d6373e00&scoped=true&", function () {
      api.rerender('d6373e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85aCiZ4xA6Rje/JS/comp/PopupBox.vue"
export default component.exports